import {IdlocaGeneric} from "../locales/IdlocaGeneric";
import {RoutesPath} from "../enums/RoutesPath";

export interface IMenuConfig {
    localeId: IdlocaGeneric;
    redirectUrl: RoutesPath;
}

export const menuConfig: IMenuConfig[] = [
    {
        localeId: IdlocaGeneric.catalogue,
        redirectUrl: RoutesPath.CATALOGUE,
    },
    {
        localeId: IdlocaGeneric.buy_motorcycles,
        redirectUrl: RoutesPath.BUY_MOTORCYCLES,
    },
    {
        localeId: IdlocaGeneric.buy_parts,
        redirectUrl: RoutesPath.BUY_PARTS,
    },
    {
        localeId: IdlocaGeneric.reviews,
        redirectUrl: RoutesPath.REVIEWS,
    },
    {
        localeId: IdlocaGeneric.moto_garages,
        redirectUrl: RoutesPath.MOTO_GARAGES,
    },
];
